module.exports = __webpack_public_path__ + "img/barcode-check.989241b.png";